import type { FC } from 'react';
import Slider from 'react-slick';
import * as Styled from './styled';
import type { TestimonialCardContainerProps } from './types';

export const TestimonialCardContainer: FC<TestimonialCardContainerProps> = (props) => {
  const { items, ...rest } = props;

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: Math.min(items?.length || 0, 4),
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    centerPadding: '60px',
    centerMode: true,
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Styled.Wrapper {...rest}>
      <Slider {...settings}>
        {items.map((item, index) => (
          <Styled.ItemWrapper key={index}>
            <Styled.Item>
              <Styled.ItemName>{item.name}</Styled.ItemName>
              <Styled.ItemText>{item.text}</Styled.ItemText>
              <Styled.ItemBackgroundImage>
                <img src={item.image} alt="testimonial_people" />
              </Styled.ItemBackgroundImage>
            </Styled.Item>
          </Styled.ItemWrapper>
        ))}
      </Slider>
    </Styled.Wrapper>
  );
};
